
import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { RiRefreshLine } from "react-icons/ri";
import { IoSearchOutline } from "react-icons/io5";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import LeaseApiService from '../../services/apiService';
import WindowedSelect from 'react-windowed-select';
import { FaSave, FaChevronLeft } from "react-icons/fa";
import { ClipLoader } from "react-spinners";
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment/moment';


const LeasePosting = () => {
    const [FilterTab, setFilterTab] = useState(true);
    const [Tab, setTab] = useState(true);
    const [dataList, setDataList] = useState([]);
    const apiService = new LeaseApiService();
    const [loading, setloader] = useState(false);
    const [saveLoader, setloading] = useState(false);
    const [periodFrom, setPeriodFrom] = useState("");
    const [contcextMenu, setContextMenu] = useState();
    const [periodTo, setPeriodTo] = useState("");
    const [postedDate, setpostedDate] = useState("");
    const [isCleared, setIscleared] = useState(false);
    const [unposted, setunposted] = useState(false);
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    const [selectedRows, setSelectedRows] = useState([]);
    const [gridApi, setGridApi] = useState(null);
    const [activeFY, setActiveFY] = useState(null);

    const onGridReady = (params) => {
        setGridApi(params.api);
    };

    useEffect(() => {
        const today = new Date();

        // Clone today's date and subtract one month
        const lastMonth = new Date(today);
        lastMonth.setMonth(today.getMonth() - 1);

        const formattedToday = today.toISOString().split("T")[0];
        const formattedLastMonth = lastMonth.toISOString().split("T")[0];

        setPeriodFrom(formattedLastMonth);
        setPeriodTo(formattedToday);
        setpostedDate(formattedToday);

        const handleClickOutside = () => setContextMenu(null);
        window.addEventListener('click', handleClickOutside);

        return () => window.removeEventListener('click', handleClickOutside);
    }, []);

    useEffect(() => {
        if (gridApi) {
            gridApi.forEachNode((node) => {
                node.setSelected(selectedRows.some(r => r.leaseNo === node.data.leaseNo));
            });
        }
    }, [dataList]);

    useEffect(() => {
        const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
        const activeFinancialYear = financialYears?.find(fy => fy.isActive);
        if (activeFinancialYear) {
            setActiveFY({ label: activeFinancialYear.name, value: activeFinancialYear });
        }
    }, []);

    const [transData, setTransData] = useState({
        debitAcc: [{ label: 'Select Debit Account', value: '' }],
        property: [{ label: 'Select Property', value: '' }],
        CraditAcc: [{ label: 'Select Credit Account', value: '' }],
        uniNo: [{ label: 'Select Unit No', value: '' }],
        Narration: ""
    });
    const handleClearFilters = () => {
        setTransData({
            debitAcc: [{ label: 'Select Debit Account', value: '' }],
            property: [{ label: 'Select Property', value: '' }],
            CraditAcc: [{ label: 'Select Credit Account', value: '' }],
            uniNo: [{ label: 'Select Unit No', value: '' }],
        });
    }
    const formatDate = (date) => {
        if (!date) return null;
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handlePeriodFromChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodFrom(formattedDate);
    }
    const handlePeriodToChange = ({ name, value }) => {
        const formattedDate = formatDate(value);
        setPeriodTo(formattedDate);
    }
    const SearchItems = async () => {
        try {
            setloader(true);
            const params = new URLSearchParams();
            params.append('PropertyNo', transData?.property?.value || 'All');
            params.append('UnitNo', transData?.uniNo?.label || 'All');
            params.append('FromDate', periodFrom);
            params.append('ToDate', periodTo);
            params.append('PMUnits', isCleared);
            params.append('UnPosted', unposted);
            const res = await apiService.getApiParamater('GET_REVENUE_LIST', `?${params.toString()}`);
            setDataList(res?.data?.result || []);
            setloader(false);
        } catch (error) {
            console.error('Error fetching items:', error);
            setloader(false);
        }
    }
    const columnDefs = [
        { checkboxSelection: true, headerCheckboxSelection: true, field: 'isSelected', width: 50, pinned: 'left' },
        { headerName: 'Group', field: 'leaseNo', filter: true, width: 200, suppressMovable: false },
        { headerName: 'Account Code', field: 'propertyName', filter: true, suppressMovable: false, width: 280 },
        { headerName: 'Account Name', field: 'unitNo', filter: true, suppressMovable: false, width: 250 },
        { headerName: 'DR', field: 'postedAmount', filter: true, suppressMovable: false, width: 250 },
        { headerName: 'CR', field: 'postedAmount', filter: true, suppressMovable: false, width: 250 },
        { headerName: 'Amount', field: 'postedAmount', filter: true, suppressMovable: false, width: 250 },
    ]
    const handleSave = async () => {
        try {
            setloading(true);
            if (selectedRows.length === 0) {
                toast.warning(`Please Select Lease from the Posting Grid`);
                setloading(false);
                return;
            }
            if (!transData?.debitAcc?.value) {
                toast.warning(`Please Select Debit Account`);
                setloading(false);
                return;
            } else if (!transData?.CraditAcc?.value) {
                toast.warning(`Please Select Credit Account`);
                setloading(false);
                return;
            }

            const _LeaseRevenuGrid = selectedRows?.map(item => {
                return {
                    isSelected: true,
                    leaseNo: item?.leaseNo,
                    propertyNo: item?.propertyNo,
                    propertyName: item?.propertyName,
                    unitNo: item?.unitNo,
                    unitRefNo: item?.unitRefNo,
                    narration: item?.narration,
                    leaseDate: item?.leaseDate,
                    leaseExpiry: item?.leaseExpiry,
                    totalLeaseDays: item?.totalLeaseDays,
                    contractValue: item?.contractValue,
                    vat: item?.vat,
                    rent: item?.rent,
                    balance: item?.balance,
                    rentPerDay: item?.rentPerDay,
                    daysToCalculate: item?.daysToCalculate,
                    postingAmount: item?.postingAmount,
                    recordId: item?.recordId,
                    postedAmount: item?.postedAmount,
                    crAcCode: item?.crAcCode === "0" ? transData?.CraditAcc?.value : item?.crAcCode,
                    crAcName: item?.crAcName === "0" ? transData?.CraditAcc?.label : item?.crAcName,
                    drAcCode: item?.drAcCode === "0" ? transData?.debitAcc?.value : item?.drAcCode,
                    drAcName: item?.drAcName === "0" ? transData?.debitAcc?.label : item?.drAcName,
                    fYear: activeFY?.value?.id,
                    isPosted: item?.isPosted
                }
            });

            const body = {
                leaseRevenueMain: {
                    propertyNo: transData?.property?.value || "",
                    unitNo: transData?.uniNo.label || "",
                    periodFrom: periodFrom,
                    periodTo: periodTo,
                    pmUnits: isCleared,
                    unPostedUnits: unposted,
                    postingDate: postedDate,
                    debitAccount: transData?.debitAcc?.value,
                    creditAccount: transData?.CraditAcc?.value,
                    refNo: "0",
                    narration: transData.Narration || "",
                    _LeaseRevenuGrid: _LeaseRevenuGrid,
                },
            };
            const postRes = await apiService.post("POST_REVENUE", body);
            if (postRes?.data?.statusCode === 201 || postRes?.data?.statusCode === 200) {
                toast.success(`Posted  successfully`);
                window.location.reload()
                setloading(false);
            } else {
                setloading(false);
            }
        } catch (error) {
            setloading(false);

            console.error("Error Save Data", error);
        }
    }
    return (
        <div className='p-3'>
            <div className="cost-center-section mb-3">
                <div className="d-flex cursor-pointer slide-header"
                    onClick={() => setFilterTab(!FilterTab)}>
                    <div className='h6 pt-1'>Search Details</div>
                </div>
                <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
                    <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                        <div className="form-group grid-contain ">
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> From Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodFrom}
                                    onChange={(date) => handlePeriodFromChange({ name: 'leaseDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className='d-flex'>
                                <label htmlFor="validationCustom01" className="form-label pt-1 start"> To Date</label>
                                <DatePicker
                                    todayButton="Today"
                                    selected={periodTo}
                                    onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                                    dateFormat="dd-MMM-yyyy"
                                    className="p-2 form-control w-100"
                                />
                            </div>
                            <div className="center d-flex gap-3">
                                {loading === true ? (
                                    <div className="mainbtnGry flex-end gap-24">
                                        <ClipLoader color="#ffffff" className="mt-1" size={25} />
                                    </div>
                                ) : (
                                    <div className="mainbtnGry flex-end gap-2" onClick={SearchItems}>
                                        <IoSearchOutline color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Search</div>
                                    </div>
                                )}
                                <div className="mainbtnRed flex-end gap-2" onClick={handleClearFilters} >
                                    <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                                    <div className="center">Reset</div>
                                </div>
                                {saveLoader === true ? (
                                    <div className="mainbtn flex-end gap-2 ">
                                        <ClipLoader color="#ffffff" className="mt-1" size={25} />
                                    </div>
                                ) : (
                                    <div className="mainbtn flex-end gap-2" onClick={handleSave}>
                                        <FaSave color="#fff" className="center mt-1 mx-2" />
                                        <div className="center">Save</div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='gridshad mt-1'>
                <div className='table-container' style={{ overflowX: 'auto', height: "490px" }}>
                    <div className="ag-theme-quartz" style={{ height: 650 }}>
                        <AgGridReact
                            getRowStyle={(params) => {
                                return { background: params.node.rowIndex % 2 === 0 ? '#F0EDF5' : '#fff' };
                            }}
                            rowData={dataList}
                            columnDefs={columnDefs}
                            suppressRowClickSelection={true}
                            rowSelection="multiple"
                            rowMultiSelectWithClick={true}
                            getRowId={(params) => params.data.leaseNo}
                            onGridReady={onGridReady}
                            onSelectionChanged={(params) => {
                                const selected = params.api.getSelectedRows();
                                setSelectedRows(selected);
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className='boxs my-3' style={{ borderRadius: '8px', padding: '10px' }}>
                <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '5px' }}>
                    <div className='d-flex gap-1'>
                        <label className="forn-label">Debit Acc </label>
                        <WindowedSelect
                            className="w-75 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}

                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',

                                        color: '#000',
                                    },
                                }),
                            }}

                        // value={data.AccountCode}
                        // onChange={(selectedOption) => handleGridChange(index, "AccountCode", selectedOption)}
                        // options={accountList?.map((rec) => ({ value: rec, label: rec?.value }))}
                        />
                    </div>
                    <div className='d-flex gap-1'>
                        <label className="forn-label">Credit Acc </label>
                        <WindowedSelect
                            className="w-75 p-0"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9
                            })}

                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            menuShouldScrollIntoView={false}
                            styles={{
                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? '#F5F5F5' : null,
                                    color: '#000',
                                    ':hover': {
                                        backgroundColor: '#F5F5F5',

                                        color: '#000',
                                    },
                                }),
                            }}

                        // value={data.AccountCode}
                        // onChange={(selectedOption) => handleGridChange(index, "AccountCode", selectedOption)}
                        // options={accountList?.map((rec) => ({ value: rec, label: rec?.value }))}
                        />
                    </div>
                    <div className='d-flex gap-1'>
                        <label className="forn-label">Trans Date </label>
                        <DatePicker
                            todayButton="Today"
                            selected={periodTo}
                            onChange={(date) => handlePeriodToChange({ name: 'toDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className='d-flex gap-1'>
                        <label className="forn-label">Amount</label>
                        <input className='p-2 form-control' type='text' placeholder='0.000' />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LeasePosting;